import { render } from "./StickerCard.vue?vue&type=template&id=5585053a&scoped=true"
import script from "./StickerCard.vue?vue&type=script&lang=js"
export * from "./StickerCard.vue?vue&type=script&lang=js"

import "./StickerCard.vue?vue&type=style&index=0&id=5585053a&scoped=true&lang=css"
import "./StickerCard.vue?vue&type=style&index=1&id=5585053a&lang=css"
import "./StickerCard.vue?vue&type=style&index=2&id=5585053a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5585053a"]])

export default __exports__